import classNames from 'classnames';
import React from 'react';
import './Table.scss';
import TableBody from './TableBody';
import TableCell from './TableCell';
import TableFoot from './TableFoot';
import TableHead from './TableHead';
import TableRow from './TableRow';

interface TableProps extends React.HTMLProps<HTMLTableElement> {
  hideMobileBorder?: boolean;
}

const Table = ({ children, hideMobileBorder = false, ...rest }: TableProps) => {
  return (
    <table
      {...rest}
      className={classNames(
        'mss-table',
        {
          'mss-table--with-border': !hideMobileBorder
        },
        rest.className
      )}
    >
      {children}
    </table>
  );
};

Table.Head = TableHead;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.Foot = TableFoot;

export default Table;
